import React, { useState } from 'react';
import { KFLInput, KFLButton, KFLIcon } from '@kamstrup/kamstrup-frontend-library';
import { CallStatus, UserInfo } from '../../../models';
import Spinner from '../spinner';
import FlaggedMsg, { FlagTypes } from '../flaggedMsg';
import { AppKeys, newMsg, newTag } from '../../../core/localization';
import { GetInfo } from '../../../hooks/useUserInfo';
import useLocale from '../../../hooks/useLocale';
import './userDetailsForm.scss';
import EksKFLWrapper from '../eks-lib/eksKFLwrapper';

interface Messages {
  emailLabel?: string;
  emailPlaceholder?: string;
  msgEmailValidating?: string;
  msgUserFound?: string;
}

const emailLabel = newMsg(AppKeys.UserDetailForm_Email_Label);
const emailPlaceholder = newMsg(AppKeys.UserDetailForm_Email_Placeholder);
const msgEmailValidating = newMsg(AppKeys.UserDetailForm_Validating);
const msgUserFound = (email: string, customerName: string) =>
  newMsg(AppKeys.UserDetailForm_UserFound, [
    newTag('email', email),
    newTag('customerName', customerName),
  ]);

interface Props {
  id: string;
  userInfo: UserInfo;
  getInfo: GetInfo;
  getInfoStatus: CallStatus;
  hideDetails?: boolean;
  messages?: Messages;
}

const UserDetailsForm: React.FC<Props> = (props) => {
  const { translate } = useLocale();
  const { id, userInfo, getInfo, getInfoStatus } = props;
  const [email, setEmail] = useState(userInfo.email);

  const hasError = getInfoStatus.errorMsg !== '';
  const hasUser = userInfo.email.length > 0;
  const hasCustomer = userInfo.customer.customerId.length !== 0;
  const showDetails = !props.hideDetails && hasCustomer;
  const getUserDetails = () => getInfo?.(email);

  return (
    <div>
      <div className="user-details-form">
        <KFLInput
          id={id + '-email'}
          label={translate(emailLabel)}
          placeholder={translate(emailPlaceholder)}
          type="email"
          value={email}
          onChange={setEmail}
          />
          <EksKFLWrapper>
          <KFLButton
            id={id + '-validate-btn'}
            variant="secondary"
            onClick={getUserDetails}
          >
            <KFLIcon name="Forward" size="xs" />
          </KFLButton>
        </EksKFLWrapper>
      </div>
      <div>
        <div>
          {getInfoStatus.isFetching ? (
            <Spinner iconSize={20} label={msgEmailValidating} />
          ) : hasError ? (
            <FlaggedMsg
              label={getInfoStatus.errorMsg}
              type={hasUser ? FlagTypes.Warning : FlagTypes.Error}
            />
          ) : (
            showDetails && (
              <FlaggedMsg
                label={msgUserFound(
                  userInfo.email,
                  userInfo.customer.customerName
                )}
                type={FlagTypes.Success}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetailsForm;
